import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatPaginatorModule } from '@angular/material/paginator';
import { FilterListModule } from 'src/app/filterlist/filterlist.module';
import { AngularMaterialModule } from 'src/app/shared/module/angular-material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { VehicleMaintenanceDetailComponent } from './vehicle-maintenance-detail.component';
import { ApplicationPipesModule } from 'src/app/shared/module/applicationPipesModule';
import { PartTableAddModule } from '../part/component/part-table-add/part-table-add.module';
import { PartTableAvailModule } from '../part/component/part-table-avail/part-table-avail.module';
import { DynamicTableModule } from 'src/app/dynamic-table/dynamic-table.module';
import { AngularSplitModule } from 'angular-split';
import { TranslateModule } from '@ngx-translate/core';
import { DropdownSearchableModule } from 'src/app/shared/dropdown-searchable/dropdown-searchable.module';
import { AppModule } from 'src/app/app.module';
@NgModule({
  declarations: [VehicleMaintenanceDetailComponent
  ],
  imports: [
    CommonModule,
    MatPaginatorModule,
    FilterListModule,
    AngularMaterialModule,
    ReactiveFormsModule,
    FormsModule,
    ApplicationPipesModule,
    PartTableAddModule,
    PartTableAvailModule,
    DynamicTableModule,
    AngularSplitModule,
    TranslateModule,
    DropdownSearchableModule,
  ]
})
export class VehicleMaintenanceDetailModule { }
